<template>
  <div class="row mt-4">
    <div v-for="(member, memberIndex) in filteredMembers" class="col-6 col-lg-3 mb-3">
      <div class="card h-100 text-lg-start">
        <a v-bind:href="member.url">
          <div class="image-wrap">
            <img v-if="member.imageUrl != ''" v-bind:src="member.imageUrl" v-bind:alt="member.name" class="card-img-top" />
          </div>
        </a>

        <div class="card-body d-flex flex-column">
          <div class="rte fw-medium">
            <a v-bind:href="member.url" class="text-black"><b v-html="member.name"></b></a>
            <span v-if="member.companyName != ''"><br /><span v-html="member.companyName"></span></span>
            <span v-if="member.membershipYear != '' && filter != 'pastMembers'"><br /><span v-html="member.membershipYear"></span> UAG Member</span>
          </div>
        </div>

        <div class="member-social-links" v-html="member.socialLinks"></div>
      </div>
    </div>
  </div>

  <button class="btn btn-secondary d-block mx-auto" v-if="displayLoadMoreButton" v-on:click="numberShown += increment">Load More</button>
</template>

<script>

  

  import Globals from '../../scripts/globals';

  export default {
    components: {
    },
    data() {
      let d = window.wf.memberListing;
      d.numberShown ??= -1;
      d.increment ??= d.numberShown;
      d.itemClass ??= "col-6 col-lg-3 mb-3";
      return d;
    },
    computed: {
      filteredMembers() {
        if (this.numberShown > -1) {
          return this.members.filter((el, index) => index < this.numberShown);
        } else {
          return this.members;
        }

      },
      displayLoadMoreButton() {
        if (this.showLoadMore == 'True' && this.members.length > this.numberShown) {
          return true;
        }
        return false;
      }
    }
  }
</script>
